// import WebKit from 'vue'

function closeWebView() {
  webkit.messageHandlers.jsCallbackHandler.postMessage("close");
  // console.log('close');
}
export default {
  closeWebView,
}



// WEBPACK FOOTER //
// ./src/model/closeWebView.js